<div class="row justify-content-center g-0">
  <div class="col-xs-12 col-sm-10 col-md-8 col-lg-6">
    @if(processing()) {
      <h2 class="text-center">
        <fa-icon [icon]=faSpinner [animation]="'spin'"></fa-icon>
      </h2>
    }
    @if(alert) {
      <ngb-alert [type]="alert.type">{{ alert.message }}</ngb-alert>
    }

    @if(!processing() && pool && place){
      <div class="d-flex justify-content-between my-3">
        <h2 class="me-2 text-truncate">
          <fa-icon [icon]=faRightLeft></fa-icon> 
          <app-lineicon [line]="place.getLine()" class="ms-1 mt-0"></app-lineicon>
          <span class="ms-1">{{place.getPlayer()?.getPerson()?.getName()}}</span> vervangen
        </h2>        
      </div>

      @if(selectableTeams && alreadyChosenTeams) {
        <div class="d-flex justify-content-center">
          <app-pool-player-choose class="w-100" [competitionConfig]="pool.getCompetitionConfig()"
            [viewPeriod]="pool.getAssemblePeriod().getViewPeriod()" [viewPeriodType]="TransferViewPeriod"
            [alreadyChosenPersons]="alreadyChosenPersons" [selectableTeams]="selectableTeams"
            [alreadyChosenTeams]="alreadyChosenTeams" [selectableLines]="selectableLines" [filter]="choosePlayersFilter"
            [showAll]="form.controls.showAll.value" (selectPlayer)="transfer(pool,$event, place)"
            (linkToS11Player)="linkToPlayer(pool,$event)" (filterUpdate)="updateState($event)">
          </app-pool-player-choose>
        </div>
      }
    }
  </div>
</div>